// @ts-nocheck
export const API_URL = `${import.meta.env.VITE_APP_API_URL}/api/v1/v1.1`;
export const EXPIRE_API = '/daywork_dockets/client/link/status/';
export const ACCESS_DOCUMENTS_API = '/daywork_dockets/client/access/document/';
export const PDF_DOWNLOAD_API = '/daywork_dockets/client/pdf/download/';
export const ATTACHMENT_API = '/daywork_dockets/client/create/attachment/';
export const APPROVE_REJECT_API = '/daywork_dockets/client/approval/';
